import React,{useState, useEffect} from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import './Contact.css'
import {
    Input,
    SelectList,
} from "../../../../Components/InputComps/InputComps";
import { GenderOptions } from "../../../Institute/AddStaff/OptionsArr/OptionsArr";
import ReactSelect from "react-select"; // renamed to avoid conflict

const InstructorPreferenceInformation = ({UserInformation, EnrollmentData,
     setEnrollmentData, OnChange, Styling, uniqueLanguages, uniqueGenders}) => {
        
    const Border = "border-[#E2E2E2] border-[1px] border-solid";
    const ResponsiveInpuyStyle = "text-5xs md:text-4xs lg:text-3xs";

    const { InputTypeTextStyle, DivStyle, HeadingStyle } = Styling;

    // const languageOptions = uniqueLanguages.map((lang) => ({
    //     value: lang,
    //     label: lang,
    // }));

    // const languageOptions = [
    //     ...uniqueLanguages.map((lang) => ({
    //       value: lang,
    //       label: lang,
    //     })),
    //     { value: "Any", label: "Any of these languages" },
    //   ];

    const selectedLanguages = EnrollmentData.StudentData.InstructorPreferredLanguages || [];

    const languageOptions = uniqueLanguages.map((lang) => ({
    value: lang,
    label: lang,
    isDisabled: selectedLanguages.includes("Any of these languages"), // Disable all if "Any" is selected
    }));

    languageOptions.push({
    value: "Any of these languages",
    label: "Any of these languages",
    isDisabled: selectedLanguages.length > 0 && selectedLanguages.some((lang) => lang !== "Any"), // Disable "Any" if other langs are selected
    });


return (
    <div className="w-full lg:mt-[-20px] flex flex-col lg:flex-row gap-[20px] lg:gap-[50px]">
        <div className={DivStyle}>
        <label htmlFor="instructorGender" className="text-[22px] mb-[-15px]">Instructor Gender</label>
        <select
        id="instructorGender"
        className={`flex w-full rounded-md bg-white py-2 px-4 ${Border} shadow-[4px_5px_6px_#00000029] ${ResponsiveInpuyStyle}`}
        value={EnrollmentData.StudentData.InstructorPreferredGender}
        onChange={(e) =>
            setEnrollmentData((prev) => ({
            ...prev,
            StudentData: {
                ...prev.StudentData,
                InstructorPreferredGender: e.target.value,
            },
            }))
        }
        >
        <option value="">Select Gender</option>
        {uniqueGenders.map((gender) => (
            <option key={gender} value={gender}>
            {gender}
            </option>
        ))}
        <option value="Any">Any Gender</option>
        </select>

                {/* <div className="w-full sm:mt-[20px] lg:mt-[0px]">

                    <SelectList
                        Label="Instructor Gender"
                        Id="InstructorGender"
                        defaultValue=""
                        selectedValue={'Male'}
                        Text="Instructor Gender"
                        OptionsArr={GenderOptions}
                        State={EnrollmentData?.StudentData?.InstructorPreferredGender}
                        onChange={(e) => OnChange(e, "InstructorPreferredGender")}
                    />
                </div> */}
        </div>

        <div className={DivStyle}>
            <p className="text-[22px] mb-[-15px]">Instruction Language Preference</p>
            <div className="w-full">
                <ReactSelect
                    options={languageOptions}
                    isMulti
                    placeholder="Select preferred languages"
                    onChange={(selectedOptions) => {
                        const selectedLangs = selectedOptions.map((opt) => opt.value);
                        setEnrollmentData((prev) => ({
                            ...prev,
                            StudentData: {
                                ...prev.StudentData,
                                InstructorPreferredLanguages: selectedLangs,
                            },
                        }));
                    }}
                    value={languageOptions.filter((opt) =>
                        EnrollmentData.StudentData.InstructorPreferredLanguages?.includes(opt.value)
                    )}
                    // styles={{
                    //     control: (base) => ({
                    //         ...base,
                    //         height: '48px', // match typical input height
                    //         minHeight: '48px',
                    //     }),
                    // }}
                    styles={{
                        control: (base, state) => ({
                            ...base,
                            width: '100%',
                            paddingTop: '5px',    // py-2
                            paddingBottom: '5px',
                            paddingLeft: '10px',     // px-[10px]
                            paddingRight: '10px',
                            borderRadius: '0.375rem', // rounded-md
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)', // shadow-md
                            border: state.isFocused ? '1px solid #60A5FA' : '1px solid #d1d5db', // Tailwind border/gray-300
                            '&:hover': {
                                borderColor: '#60A5FA',
                            },
                        }),
                        multiValue: (base) => ({
                            ...base,
                            backgroundColor: '#E5E7EB', // gray-200
                        }),
                        multiValueLabel: (base) => ({
                            ...base,
                            color: '#374151', // gray-700
                        }),
                        multiValueRemove: (base) => ({
                            ...base,
                            color: '#6B7280', // gray-500
                            ':hover': {
                                backgroundColor: '#F87171', // red-400
                                color: 'white',
                            },
                        }),
                    }}

                />
            </div>
        </div>

    </div>
);
};

export default InstructorPreferenceInformation;
